var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "181",
        height: "137",
        viewBox: "0 0 181 137",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", { attrs: { width: "181", height: "136", fill: "#E40089" } }),
      _c("path", {
        attrs: {
          d: "M90.3346 20L178.669 136.25H2L90.3346 20Z",
          fill: "#FF45B4",
        },
      }),
      _c("path", { attrs: { d: "M90 64L145 136H35L90 64Z", fill: "#E40089" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }